import { IPlotToShow } from "../GOMCurrent/GOMCurrentPage";

interface Props {
    plots: IPlotToShow[],
    chartTypeToShow: string,
    setChartTypeToShow: (chartTypeToShow: string) => void
}

export function ChartSelector(props: Props): React.JSX.Element {

    const mapParameterGroupToLabel = {
        "CurrentProfile": "Vertical Profile",
        "HorizontalCurrentProfile": "Horizontal Profile",
    }

    return (

        <select
            onChange={(event) => {
                props.setChartTypeToShow(event.target.value)
            } }
        >
            {props.plots.map((plot, idx) => (
                <option
                    value={`${plot.parameterGroup}`}
                    // selected={plot.parameterGroup == props.chartTypeToShow ? true : false}
                    key={idx}
                >
                    {mapParameterGroupToLabel[plot.parameterGroup] ?? plot.parameterGroup}
                </option>
            ))}
        </select>

    );
};